import EpisodeDescription from './EpisodeDescription';
import type { EpisodeDescriptionProps } from './types';

export default EpisodeDescription;
export type { EpisodeDescriptionProps };
